import swal from "sweetalert";

const alertUtils = {
    info(message) {
        return swal(message, {
            icon: "info",
            buttons: "확인",
        });
    },

    success(message) {
        return swal(message, {
            icon: "success",
            buttons: "확인",
        });
    },

    successWithCallback(message, callback) {
        return swal(message, {
            icon: "success",
            buttons: "확인",
        }).then((ok) => {
            if (ok && callback) callback();
        });
    },

    warning(message) {
        return swal(message, {
            icon: "warning",
            buttons: "확인",
        });
    },

    warningWithCallback(message, callback) {
        return swal(message, {
            icon: "warning",
            buttons: "닫기",
        }).then((ok) => {
            if (ok && callback) callback();
        });
    },

    error(message) {
        return swal(message, {
            icon: "error",
            buttons: "확인",
        });
    },

    confirm(message, callback) {
        const handleKeyDown = (e) => {
            if (e.key === "Enter") {
                const confirmButton = document.querySelector(".swal-button--confirm");
                if (confirmButton) {
                    confirmButton.click();
                }
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return swal(message, {
            icon: "info",
            buttons: {
                confirm: "확인",
                cancel: "취소",
            },
            dangerMode: false,
        }).then((ok) => {
            document.removeEventListener("keydown", handleKeyDown);

            if (ok && callback) {
                callback();
            }
        });
    },
};

export default alertUtils;